'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _TableCell = require('./TableCell');

var _TableCell2 = _interopRequireDefault(_TableCell);

var _ExpandIcon = require('./ExpandIcon');

var _ExpandIcon2 = _interopRequireDefault(_ExpandIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableRow = _react2["default"].createClass({
  displayName: 'TableRow',

  propTypes: {
    onDestroy: _react.PropTypes.func,
    onRowClick: _react.PropTypes.func,
    record: _react.PropTypes.object,
    prefixCls: _react.PropTypes.string,
    expandIconColumnIndex: _react.PropTypes.number,
    onHover: _react.PropTypes.func,
    columns: _react.PropTypes.array,
    style: _react.PropTypes.object,
    visible: _react.PropTypes.bool,
    index: _react.PropTypes.number,
    hoverKey: _react.PropTypes.any,
    expanded: _react.PropTypes.bool,
    expandable: _react.PropTypes.any,
    onExpand: _react.PropTypes.func,
    needIndentSpaced: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    indent: _react.PropTypes.number,
    indentSize: _react.PropTypes.number,
    expandIconAsCell: _react.PropTypes.bool,
    expandRowByClick: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onRowClick: function onRowClick() {},
      onDestroy: function onDestroy() {},

      expandIconColumnIndex: 0,
      expandRowByClick: false,
      onHover: function onHover() {}
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return !(0, _shallowequal2["default"])(nextProps, this.props);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.props.onDestroy(this.props.record);
  },
  onRowClick: function onRowClick(event) {
    var _props = this.props;
    var record = _props.record;
    var index = _props.index;
    var onRowClick = _props.onRowClick;
    var expandable = _props.expandable;
    var expandRowByClick = _props.expandRowByClick;
    var expanded = _props.expanded;
    var onExpand = _props.onExpand;


    if (expandable && expandRowByClick) {
      onExpand(!expanded, record);
    }
    onRowClick(record, index, event);
  },
  onMouseEnter: function onMouseEnter() {
    var _props2 = this.props;
    var onHover = _props2.onHover;
    var hoverKey = _props2.hoverKey;

    onHover(true, hoverKey);
  },
  onMouseLeave: function onMouseLeave() {
    var _props3 = this.props;
    var onHover = _props3.onHover;
    var hoverKey = _props3.hoverKey;

    onHover(false, hoverKey);
  },
  render: function render() {
    var _props4 = this.props;
    var prefixCls = _props4.prefixCls;
    var columns = _props4.columns;
    var record = _props4.record;
    var style = _props4.style;
    var visible = _props4.visible;
    var index = _props4.index;
    var expandIconColumnIndex = _props4.expandIconColumnIndex;
    var expandIconAsCell = _props4.expandIconAsCell;
    var expanded = _props4.expanded;
    var expandRowByClick = _props4.expandRowByClick;
    var expandable = _props4.expandable;
    var onExpand = _props4.onExpand;
    var needIndentSpaced = _props4.needIndentSpaced;
    var className = _props4.className;
    var indent = _props4.indent;
    var indentSize = _props4.indentSize;


    var cells = [];

    for (var i = 0; i < columns.length; i++) {
      if (expandIconAsCell && i === 0) {
        cells.push(_react2["default"].createElement(
          'td',
          {
            className: prefixCls + '-expand-icon-cell',
            key: 'rc-table-expand-icon-cell'
          },
          _react2["default"].createElement(_ExpandIcon2["default"], {
            expandable: expandable,
            prefixCls: prefixCls,
            onExpand: onExpand,
            needIndentSpaced: needIndentSpaced,
            expanded: expanded,
            record: record
          })
        ));
      }
      var isColumnHaveExpandIcon = expandIconAsCell || expandRowByClick ? false : i === expandIconColumnIndex;
      cells.push(_react2["default"].createElement(_TableCell2["default"], {
        prefixCls: prefixCls,
        record: record,
        indentSize: indentSize,
        indent: indent,
        index: index,
        expandable: expandable,
        onExpand: onExpand,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        isColumnHaveExpandIcon: isColumnHaveExpandIcon,
        column: columns[i],
        key: columns[i].key
      }));
    }

    return _react2["default"].createElement(
      'tr',
      {
        onClick: this.onRowClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: prefixCls + ' ' + className + ' ' + prefixCls + '-level-' + indent,
        style: visible ? style : _extends({}, style, { display: 'none' })
      },
      cells
    );
  }
});

exports["default"] = TableRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/~/rc-table/lib/TableRow.js
// module id = 285
// module chunks = 0